import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applySocialMeta } from '../utils/socialMeta';
import { getDefaultMetaForPath } from '../utils/siteMeta';

const RouteMeta = () => {
  const location = useLocation();

  useEffect(() => {
    const metadata = getDefaultMetaForPath(location.pathname);
    applySocialMeta(metadata);
  }, [location.pathname]);

  return null;
};

export default RouteMeta;
